import * as React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function UserIcon({ user, ...props } = {}) {
  const image = (
    <GatsbyImage
      image={getImage(user.thumbnail)}
      alt={user.first_name}
      title={user.full_name}
      className="text-center"
    />
  );
  return (
    <div className="user-icon rounded-circle overflow-hidden" {...props}>
      {image}
    </div>
  );
}

export default UserIcon;
